import { render } from "./CustomCard.vue?vue&type=template&id=69fe4879&scoped=true"
import script from "./CustomCard.vue?vue&type=script&lang=js"
export * from "./CustomCard.vue?vue&type=script&lang=js"

import "./CustomCard.vue?vue&type=style&index=0&id=69fe4879&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69fe4879"]])

export default __exports__